import React from 'react';
import { parseISO } from "date-fns";
import { formatInTimeZone } from 'date-fns-tz';
import { Table, Label, Button, Icon, Segment, Image } from 'semantic-ui-react'

import { DEFAULT_TIMEZONE } from '../CloudApi/Constants.js';

export default class ProductsTable extends React.Component {
    constructor(props) {
        super(props);
        // Initialize expandedRows with all product IDs set to true for auto-expansion
        const expandedRows = {};
        if (props.productsList) {
            props.productsList.forEach(product => {
                // Expand all products by default, regardless of variant count
                expandedRows[product.id] = true;
            });
        }
        
        this.state = {
            expandedRows
        };
    }

    // When products list changes, update the expanded state
    componentDidUpdate(prevProps) {
        if (prevProps.productsList !== this.props.productsList) {
            const expandedRows = {...this.state.expandedRows};
            this.props.productsList.forEach(product => {
                if (expandedRows[product.id] === undefined) {
                    expandedRows[product.id] = true;
                }
            });
            this.setState({ expandedRows });
        }
    }

    toggleRowExpansion = (productId) => {
        this.setState(prevState => ({
            expandedRows: {
                ...prevState.expandedRows,
                [productId]: !prevState.expandedRows[productId]
            }
        }));
    }

    render() {
        if (this.props.loading) {
            return (
                <Segment basic loading={this.props.loading} />
            );
        }

        // Define consistent column widths
        const columnWidths = {
            toggle: '5%',
            image: '15%',
            details: '40%',
            vendor: '20%',
            meta: '20%'
        };

        return (
            <div>
                {this.props.productsList.map((product, index) => {
                    // Parse the ISO date string
                    const createdAtDateTime = parseISO(product.created_at);
                    const createdAt = formatInTimeZone(createdAtDateTime, DEFAULT_TIMEZONE, 'PPp z');
                    
                    const hasVariants = product.variants && product.variants.length > 0;
                    const isExpanded = this.state.expandedRows[product.id] || false;
                    
                    return (
                        <Segment key={index} raised style={{ marginBottom: '1.5em' }}>
                            <Table celled fixed>
                                <Table.Header>
                                    <Table.Row style={{ backgroundColor: '#f9fafb' }}>
                                        <Table.HeaderCell width={1} style={{ width: columnWidths.toggle }}>
                                            <Button 
                                                icon 
                                                size="mini" 
                                                onClick={() => this.toggleRowExpansion(product.id)}
                                            >
                                                <Icon name={isExpanded ? 'chevron down' : 'chevron right'} />
                                            </Button>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell style={{ width: columnWidths.image }}>
                                            {product.image && (
                                                <Image src={product.image.src} size="tiny" />
                                            )}
                                        </Table.HeaderCell>
                                        <Table.HeaderCell style={{ width: columnWidths.details }}>
                                            <div style={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                                                {product.title}
                                            </div>
                                            <div style={{ marginTop: '0.5em', color: '#666' }}>
                                                ID: <a href={`/products/${product.id}`}>{product.id}</a>
                                            </div>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell style={{ width: columnWidths.vendor }}>
                                            <div>Vendor: {product.vendor}</div>
                                            <div style={{ marginTop: '0.5em' }}>
                                                <Label color={product.status === "active" ? "green" : "grey"}>
                                                    {product.status}
                                                </Label>
                                            </div>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell style={{ width: columnWidths.meta }}>
                                            <div>Created: {createdAt}</div>
                                            <div style={{ marginTop: '0.5em' }}>
                                                <Button.Group size="tiny">
                                                    <Button primary icon>
                                                        <Icon name='edit' />
                                                    </Button>
                                                    <Button color="blue" icon>
                                                        <Icon name='eye' />
                                                    </Button>
                                                </Button.Group>
                                            </div>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                            </Table>
                            
                            {isExpanded && hasVariants && (
                                <Table compact size="small">
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell width={2}>Variant ID</Table.HeaderCell>
                                            <Table.HeaderCell width={4}>Title</Table.HeaderCell>
                                            <Table.HeaderCell width={2}>SKU</Table.HeaderCell>
                                            <Table.HeaderCell width={1}>Price</Table.HeaderCell>
                                            <Table.HeaderCell width={1}>Inventory</Table.HeaderCell>
                                            <Table.HeaderCell width={4}>Options</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {product.variants.map((variant, vIndex) => (
                                            <Table.Row key={vIndex}>
                                                <Table.Cell>{variant.id}</Table.Cell>
                                                <Table.Cell>{variant.title}</Table.Cell>
                                                <Table.Cell>{variant.sku}</Table.Cell>
                                                <Table.Cell>${variant.price}</Table.Cell>
                                                <Table.Cell>
                                                    <Label color={variant.inventory_quantity > 0 ? "green" : "red"}>
                                                        {variant.inventory_quantity}
                                                    </Label>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {variant.option1 && <Label size="tiny">{variant.option1}</Label>}
                                                    {variant.option2 && <Label size="tiny">{variant.option2}</Label>}
                                                    {variant.option3 && <Label size="tiny">{variant.option3}</Label>}
                                                </Table.Cell>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                            )}
                        </Segment>
                    );
                })}
            </div>
        );
    }
}
